import config from '@/config'
import moment from 'moment'
import useIframe from '@/pages/study/composables/useIframe'
import { Dialog, Toast } from 'vant'

const localStorage = window.localStorage
const sessionStorage = window.sessionStorage

export function durationFormat(t, format) {
  const a = [
    {
      k: 'S+',
      dur: 1000,
    },
    {
      k: 's+',
      dur: 60,
    },
    {
      k: 'm+',
      dur: 60,
    },
    {
      k: 'H+',
      dur: 24,
    },
    {
      k: 'd+',
      dur: 30,
    },
    // { 暂不支持月份，因为一个月不一定是30天
    //     k: 'M+',
    //     dur: 12
    // }
  ]
  const res = a.reduce(
    (prev, item, index) => {
      const next = {}
      let dur
      const lastMatch = !a
        .slice(index + 1)
        .some(el => new RegExp('(' + el.k + ')').test(prev.val))
      if (index === a.length || lastMatch) {
        dur = Math.floor(prev.t)
      } else {
        dur = Math.floor(prev.t % item.dur)
      }
      next.t = prev.t / item.dur
      if (new RegExp('(' + item.k + ')').test(format)) {
        const [$1] = prev.val.match(new RegExp('(' + item.k + ')'))
        next.val = prev.val.replace(
          $1,
          $1.length === 1
            ? dur
            : (
                Array.from({ length: $1.length }, () => '0').join('') + dur
              ).slice(('' + dur).length)
        )
      } else {
        next.val = prev.val
      }
      return next
    },
    {
      val: format,
      t,
    }
  )
  return res.val
}
// 设置localStorage存储数据
export const setLocal = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  localStorage.setItem(name, content)
}

// 获取localStorage存储数据
export const getLocal = name => {
  if (!name) return
  let value = localStorage.getItem(name)
  if (value !== null) {
    try {
      // 数字超过最大值时，JSON.parse 会把数字进1
      if (isNaN(parseFloat(value))) {
        value = JSON.parse(value)
      }
    } catch (error) {
      // eslint-disable-next-line no-unused-expressions
      value
    }
  }
  return value
}

// 删除localStorage存储数据
export const removeLocal = name => {
  if (!name) return
  localStorage.removeItem(name)
}

// 设置sessionStorage存储数据
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  sessionStorage.setItem(name, content)
}

// 获取sessionStorage存储数据
export const getSession = name => {
  if (!name) return
  let value = sessionStorage.getItem(name)
  if (value !== null) {
    try {
      value = JSON.parse(value)
    } catch (error) {
      // eslint-disable-next-line no-unused-expressions
      value
    }
  }
  return value
}

// 删除sessionStorage存储数据
export const removeSession = name => {
  if (!name) return
  sessionStorage.removeItem(name)
}

// 获取token
export const getToken = () => {
  const data = getLocal(`${config.TOKEN_KEY}`)
  if (data && data.token) {
    return data.token
  }
  return ''
}

/**
 * @description 获取cookie
 * @param {String} cookieName
 */
export const getCookie = cookieName => {
  var result
  const cookie = document.cookie
  var arr = cookie.split(';')
  for (const item of arr) {
    const name = item.slice(0, item.indexOf('=')).replace(/\s+/, '')
    const value = item.slice(item.indexOf('=') + 1)
    if (name === cookieName) {
      result = value
    }
  }
  return result || ''
}
// 删除cookie（支持传正则批量删除）
export function delCookie(name, domain = location.hostname) {
  if (name instanceof RegExp) {
    let cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const _name = cookies[i].split('=')[0]
      if (name.test(_name)) {
        // console.log(_name + '=;expires=' + new Date(0).toUTCString())
        document.cookie = `${_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=${domain}`
      }
    }
  } else if (typeof name == 'string') {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=${domain}`
  }
}
export const cookieKey = 'zbvz_userid'
// 获取自己的cookie
export const getMyCookie = () => getCookie(cookieKey)
// 设置用户cookie 注意url有端口号的时候会写入失败
export const setMyCookie = (val, cookiedomain) => {
  let subhost = ''
  let subhostArr = location.host.split('.')
  subhostArr.shift()
  subhost = '.' + subhostArr.join('.')
  Cookies.set(cookieKey, val, { domain: '.' + location.host, path: '/' })
  Cookies.set(cookieKey, val, { domain: location.host, path: '/' })
  cookiedomain &&
    Cookies.set(cookieKey, val, { domain: cookiedomain, path: '/' })
  Cookies.set(cookieKey, val, { domain: subhost, path: '/' })
}
export const delMyCookie = () => {
  delCookie(cookieKey, '.vzan.com')
  try {
    const arr = location.host.split('.')
    if (arr.length === 3) {
      delCookie(cookieKey, `.${arr.join('.')}`)
      delCookie(cookieKey, `.${arr.slice(-2).join('.')}`)
    }
    if (arr.length > 3) {
      delCookie(cookieKey, `.${arr.join('.')}`)
      delCookie(cookieKey, `.${arr.slice(-2).join('.')}`)
      delCookie(cookieKey, `.${arr.slice(-3).join('.')}`)
    }
  } catch (error) {
    console.log(error)
  }
  removeMyToken()
}
// 获取自己的token
export const getMyToken = () => localStorage.getItem('Authorization')
// 移除token
export function removeMyToken() {
  localStorage.removeItem('Authorization')
}

/**
 * @method 时间格式化
 * @param {string} time
 * @param {string} format yyyy/mm/dd hh:ii:ss(2019/07/24 09:45:43) yy/m/d hh:ii:ss(19/07/24 09:45:43) yyyy/mm/dd w(2019/07/24 星期三) mm/dd/yyyy(07/24/2019)
 * @returns
 */
export const formatTime = (time, format = 'yyyy-mm-dd') => {
  if (format === 1) {
    format = 'yyyy-mm-dd hh:ii:ss'
  }
  if (typeof time === 'string') {
    time = time.replaceAll('-', '/')
  }
  let d = ''
  try {
    switch (typeof time) {
      case 'number':
        d = new Date(time)
        break
      case 'string':
        d = new Date(time.replace(/-/g, '-'))
        break
      case 'object':
        d = time
        break
      default:
        d = new Date()
        break
    }
  } catch (error) {
    console.log(error)
  }

  // const d =
  //   typeof time == 'number'
  //     ? new Date(time)
  //     : time
  //     ? new Date(time.replace(/-/g, '-'))
  //     : new Date()
  const t = i => {
    return (i < 10 ? '0' : '') + i
  }

  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hour = d.getHours()
  const minutes = d.getMinutes()
  const seconds = d.getSeconds()
  const weekday = d.getDay()

  return format.replace(
    /(yy){1,2}|m{1,2}|d{1,2}|h{1,2}|i{1,2}|s{1,2}|w{1,2}/gi,
    function (r) {
      switch (r.toUpperCase()) {
        case 'YY':
          return ('' + year).substr(2)
        case 'YYYY':
          return year
        case 'M':
          return month
        case 'MM':
          return t(month)
        case 'D':
          return day
        case 'DD':
          return t(day)
        case 'H':
          return hour
        case 'HH':
          return t(hour)
        case 'I':
          return minutes
        case 'II':
          return t(minutes)
        case 'S':
          return seconds
        case 'SS':
          return t(seconds)
        case 'W':
          return `星期${['日', '一', '二', '三', '四', '五', '六'][weekday]}`
        case 'WW':
          return [
            'Sunday',
            'Monday',
            'TuesDay',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ][weekday]
      }
    }
  )
}

/** 是否是国科app嵌入h5 */
export const isGkApp = () => {
  return /guokeApp/g.test(navigator.userAgent)
}

/** 是否是微赞app嵌入h5 */
export const isVzanApp = () => {
  const query = getParams()
  return /vzanApp/g.test(navigator.userAgent) || query.isVzanAppTest === '1'
}

export function isApp() {
  return (
    navigator.userAgent.includes('thirdappviewvzan') ||
    navigator.userAgent.includes('InAppPay') ||
    navigator.userAgent.includes('zhiboApp') ||
    navigator.userAgent.includes('Vzan/miniAppPayment') ||
    isVzanApp()
  )
}

// 获取移动端 UA
export const isMobile = type => {
  if (type == 'android') {
    return /android/i.test(navigator.userAgent)
  }
  if (type == 'iphone') {
    return /iphone/i.test(navigator.userAgent)
  }
  return /phone|ipad|android/i.test(navigator.userAgent)
}

// 是否ios
export const isIOS = () => {
  return /iphone|ipad|ipod/g.test(navigator.userAgent.toLowerCase())
}

// 判断企业微信
export const isWorkWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    ua.match(/wxwork/i) == 'wxwork'
  ) {
    return true
  } else {
    return false
  }
}

/** 判断PC企业微信 */
export const isPcWorkWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    ua.match(/wxwork/i) == 'wxwork' &&
    (ua.includes('windows') || (ua.includes('mac') && !ua.includes('iphone')))
  ) {
    return true
  } else {
    return false
  }
}

// 判断微信
export const isWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 判断PC微信
export const isPcWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    (ua.includes('windows') || (ua.includes('mac') && !ua.includes('iphone')))
  ) {
    return true
  } else {
    return false
  }
}

/**
 * @description 函数防抖
 * @param {Function} method 延时调用函数
 * @param {Number} wait 延迟时长
 * @param {Boolean} immediate 立即执行选项
 */
export const Ddebounce = (method, wait, immediate) => {
  if (typeof method !== 'function') {
    throw new TypeError('Expected a function')
  }
  let timeout
  // Ddebounce函数为返回值
  // 使用Async/Await处理异步，如果函数异步执行，等待setTimeout执行完，拿到原函数返回值后将其返回
  // args为返回函数调用时传入的参数，传给method
  const Ddebounce = function (...args) {
    return new Promise(resolve => {
      // 用于记录原函数执行结果
      let result
      // 将method执行时this的指向设为 debounce 返回的函数被调用时的this指向
      const context = this
      // 如果存在定时器则将其清除
      if (timeout) {
        clearTimeout(timeout)
      }
      // 立即执行需要两个条件，一是immediate为true，二是timeout未被赋值或被置为null
      if (immediate) {
        // 如果定时器不存在，则立即执行，并设置一个定时器，wait毫秒后将定时器置为null
        // 这样确保立即执行后wait毫秒内不会被再次触发
        const callNow = !timeout
        timeout = setTimeout(() => {
          timeout = null
        }, wait)
        // 如果满足上述两个条件，则立即执行并记录其执行结果
        if (callNow) {
          result = method.apply(context, args)
          resolve(result)
        }
      } else {
        // 如果immediate为false，则等待函数执行并记录其执行结果
        // 并将Promise状态置为fullfilled，以使函数继续执行
        timeout = setTimeout(() => {
          // args是一个数组，所以使用fn.apply
          // 也可写作method.call(context, ...args)
          result = method.apply(context, args)
          resolve(result)
        }, wait)
      }
    })
  }

  // 在返回的 Ddebounce 函数上添加取消方法
  Ddebounce.cancel = function () {
    clearTimeout(timeout)
    timeout = null
  }
  return Ddebounce
}

/**
 * @method 节流
 * @param {*} func
 * @param {*} delay
 */
export const Dthrottle = (func, delay) => {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    if (!timer) {
      timer = setTimeout(function () {
        func.apply(context, args)
        timer = null
      }, delay)
    }
  }
}

/**
 * @description 复制
 * @param {Node} node dom节点
 */
export const isCopy = node => {
  const range = document.createRange()
  const selection = window.getSelection()
  range.selectNode(node)
  selection.removeAllRanges()
  selection.addRange(range)
  const bool = document.execCommand('copy', 'false', null)
  document.execCommand('unselect', 'false', null)
  if (bool) {
    return true
  } else {
    return false
  }
}

/**
 * @description 判断对象是否相等
 * @param {Object} x
 * @param {Object} y
 */
export const deepEqual = (x, y) => {
  if (x === y) return true
  if (
    typeof x === 'object' &&
    x != null &&
    typeof y === 'object' &&
    y != null
  ) {
    // eslint-disable-next-line eqeqeq
    if (Object.keys(x).length != Object.keys(y).length) return false

    for (const prop in x) {
      // eslint-disable-next-line no-prototype-builtins
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) return false
      } else return false
    }
    return true
  } else return false
}

/**
 * @description 用于域名返回处理
 */
export const originUrl = () => {
  let origin = window.location.origin
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname.includes('192.168.')
  ) {
    origin = 'http://testvt.vzan.com'
  }
  return origin
}

/**
 * 数量转换，单位：万、千万
 * @param {*} number
 */
export const numberConvert = (number = 0) => {
  if (number > 10000000) {
    return (number / 10000000).toFixed(2) + '千万'
  }
  if (number > 10000) {
    return (number / 10000).toFixed(2) + '万'
  }
  return number
}

/**
 * 重置图片大小
 * @param {*图片链接} imgurl
 * @param {*宽度} width
 * @param {*高度} height
 * @param {*是否开启水印} iswater
 * @param {*水印地址base64编码} watermarkurl
 * @param {*水印X轴位置} posx
 * @param {*水印Y轴位置} posy
 */
export const resizeImg = (
  imgurl,
  width,
  height,
  iswater,
  watermarkurl,
  posx,
  posy,
  quality = 100
) => {
  // eslint-disable-next-line eqeqeq
  if (imgurl == null || imgurl == undefined || imgurl == '') return ''

  imgurl = imgurl.replace('vzan-img.oss-cn-hangzhou.aliyuncs.com', 'i.vzan.com')
  if (
    imgurl.indexOf('//i2.vzan.com/') > -1 &&
    imgurl.indexOf('imageView2') < 0
  ) {
    // eslint-disable-next-line eqeqeq
    if (iswater == 1 && watermarkurl != '' && watermarkurl != undefined) {
      imgurl = imgurl.replace('i2.vzan.com', 'i2cut.vzan.com')
      imgurl +=
        '?watermark/1/image/' +
        watermarkurl +
        '/gravity/northwest/dx/' +
        posx +
        '/dy/' +
        posy
    }
    if (imgurl.indexOf('watermark') > -1) {
      imgurl += '|'
    } else {
      imgurl += '?'
    }
    if (width && height && width > 0 && height > 0) {
      imgurl =
        imgurl.replace('i2.vzan.com', 'i2cut.vzan.com') +
        'imageMogr2/auto-orient/crop/' +
        width * 2 +
        'x' +
        height * 2 +
        '!/quality/' +
        quality
    } else if (width && width > 0) {
      imgurl =
        imgurl.replace('i2.vzan.com', 'i2cut.vzan.com') +
        'imageMogr2/auto-orient/thumbnail/' +
        width * 2 +
        'x/quality/' +
        quality
    } else if (height && height > 0) {
      imgurl =
        imgurl.replace('i2.vzan.com', 'i2cut.vzan.com') +
        'imageMogr2/auto-orient/thumbnail/x' +
        height * 2 +
        '/quality/' +
        quality
    } else if (!width && !height) {
      imgurl =
        imgurl.replace('i2.vzan.com', 'i2cut.vzan.com') +
        'imageMogr2/auto-orient/quality/' +
        quality
    }
    return imgurl
  } else if (
    imgurl.indexOf('//i.vzan.com/') > -1 &&
    imgurl.indexOf('imageView2') < 0
  ) {
    if (width && height && width > 0 && height > 0) {
      return (
        imgurl.replace('i.vzan.com', 'icut.vzan.com') +
        '?imageMogr2/auto-orient/crop/' +
        width * 2 +
        'x' +
        height * 2 +
        '!/quality/' +
        quality
      )
    } else if (width && width > 0) {
      return (
        imgurl.replace('i.vzan.com', 'icut.vzan.com') +
        '?imageMogr2/auto-orient/thumbnail/' +
        width * 2 +
        'x/quality/' +
        quality
      )
    } else if (height && height > 0) {
      return (
        imgurl.replace('i.vzan.com', 'icut.vzan.com') +
        '?imageMogr2/auto-orient/thumbnail/x' +
        height * 2 +
        '/quality/' +
        quality
      )
    }
    return imgurl
  } else if (
    imgurl.indexOf('//i.vzan.com/') > -1 &&
    imgurl.indexOf('?x-oss-process') < 0
  ) {
    if (width && width > 0 && height && height > 0) {
      imgurl +=
        '?x-oss-process=image/resize,limit_0,m_fill,w_' +
        width +
        ',h_' +
        height +
        '/format,'
    } else if (height && height > 0) {
      imgurl += '?x-oss-process=image/resize,h_' + height + '/format,'
    } else if (width && width > 0) {
      imgurl += '?x-oss-process=image/resize,w_' + width + '/format,'
    }
    // eslint-disable-next-line no-return-assign
    return (imgurl += 'jpeg')
  } else {
    return imgurl.replace('j.vzan.com', 'static2.sinsam.com')
  }
}

/**
 * 时间戳格式化
 * @param {*时间戳} val
 * @param {*时间格式} format
 */
export const timestampFormat = (val, format) => {
  if (val) {
    val = val.replace('/Date(', '').replace(')/', '').replace(/-/g, '/')
    var date = new Date(isNaN(val * 1) ? val : val * 1)
    return dateFormat(date, format)
  }
  return ''
}

// 格式化单位数字
export const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * 时间格式化
 * @param {*时间} date
 * @param {*时间格式} format
 */
export const dateFormat = (date, format) => {
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()

  var hour = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()

  if (format === 'yyyy/MM/dd HH:mm:ss') {
    return (
      [year, month, day].map(formatNumber).join('/') +
      ' ' +
      [hour, minute, second].map(formatNumber).join(':')
    )
  } else if (format === 'MM-dd') {
    return [month, day].map(formatNumber).join('-')
  } else if (format === 'yyyy-MM-dd') {
    return [year, month, day].map(formatNumber).join('-')
  } else if (format === 'yyyy-MM-dd HH-HH1') {
    return (
      [year, month, day].map(formatNumber).join('-') +
      ' ' +
      formatNumber(hour) +
      ':00-' +
      formatNumber(hour) +
      ':59'
    )
  } else if (format === 'MM-dd HH:mm') {
    return (
      [month, day].map(formatNumber).join('-') +
      ' ' +
      [hour, minute].map(formatNumber).join(':')
    )
  } else if (format === 'yyyy-MM-dd HH:mm') {
    return (
      [year, month, day].map(formatNumber).join('-') +
      ' ' +
      [hour, minute].map(formatNumber).join(':')
    )
  } else {
    return (
      [year, month, day].map(formatNumber).join('-') +
      ' ' +
      [hour, minute, second].map(formatNumber).join(':')
    )
  }
}

/**
 * 获取时间倒计时字符串
 * @param {*时间戳，格式：/Date(1514178600000)/} time
 */
export const getCountDownStr = (time, date, limitDiffDay) => {
  var countDown = this.getCountDownObj(time, date)
  if (countDown) {
    if (parseInt(countDown.days)) {
      if (countDown.days >= limitDiffDay) {
        return ''
      }
      return parseInt(countDown.days) + '天后'
    } else if (parseInt(countDown.hours)) {
      return parseInt(countDown.hours) + '小时后'
    } else if (parseInt(countDown.minutes)) {
      return parseInt(countDown.minutes) + '分钟后'
    } else if (parseInt(countDown.seconds)) {
      return parseInt(countDown.seconds) + '秒钟后'
    }
  }
  return ''
}

/**
 * 获取时间倒计时对象
 * @param {*时间字符串，格式：yyyy/MM/dd HH:mm:ss} timeStr 目标时间
 */
export function getCountDownObjectByStr(timeStr, date) {
  date = date || new Date()
  timeStr = timeStr.trim().replace(/-/g, '/')
  var diffTime = new Date(timeStr) - date // 计算剩余的毫秒数
  if (isNaN(diffTime) || diffTime <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }
  }
  var days = parseInt(diffTime / 1000 / 60 / 60 / 24, 10) // 计算剩余的天数
  var hours = parseInt((diffTime / 1000 / 60 / 60) % 24, 10) // 计算剩余的小时
  var minutes = parseInt((diffTime / 1000 / 60) % 60, 10) // 计算剩余的分钟
  var seconds = parseInt((diffTime / 1000) % 60, 10) // 计算剩余的秒数
  if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }
  } else {
    return {
      days: formatNumber(days),
      hours: formatNumber(hours),
      minutes: formatNumber(minutes),
      seconds: formatNumber(seconds),
    }
  }
}

/**
 * [isMobile 判断平台]
 * @param test: 0:iPhone    1:Android
 */
export const ismobile = () => {
  var u = navigator.userAgent
  // app = navigator.appVersion
  if (
    /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
    /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(
      navigator.userAgent
    )
  ) {
    if (window.location.href.indexOf('?mobile') < 0) {
      try {
        if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
          return '0'
        } else {
          return '1'
        }
      } catch (e) {
        console.log(e)
      }
    }
  } else if (u.indexOf('iPad') > -1) {
    return '0'
  } else {
    return '1'
  }
}

// 判断pc还是移动端, 如果返回true,跳移动端。
export function getAgent() {
  if (/192.168|local/.test(window.location.host)) return 'mobile'
  const sUserAgent = navigator.userAgent.toLowerCase()
  if (sUserAgent.match(/MicroMessenger/i) == 'micromessenger') {
    return 'mobile'
  }
  const status =
    /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
      sUserAgent
    )
  return status ? 'mobile' : 'pc'
}

export function isVzanMini() {
  const par = GetParmas()
  if (par.isVzanMini == '1') {
    // 用于模拟器调试
    return true
  }
  return isMiniApp('vzanlive')
}

export const download = () => {
  if (ismobile() == 1) {
    window.location.href =
      'http://a.app.qq.com/o/simple.jsp?pkgname=cn.pengxun.vzanlive'
  } else {
    window.location.href =
      'https://itunes.apple.com/us/app/wei-zan-zhi-bo/id1142464686?l=zh&ls=1&mt=8'
  }
}

/**
 * 价格转换，分转元，保留n位小数
 * @param {*} money
 */
export const moneyConvert = (money, decimal = 2) => {
  return ((money || 0) * 0.01).toFixed(decimal || 2) || '0.00'
}

// 页面刷新，针对部分安卓不支持location.reload(),location.href=location操作
export const windowReload = () => {
  return location.reload()

  // var url = location.href
  // if (url.indexOf("?") > -1) {
  // 	url += "&"
  // } else {
  // 	url += "?"
  // }
  // url += "v=" + new Date().getTime()
  // window.location.href = url
}

/**
 * @description 获取 URL 的参数
 * @return {Object} {} 参数对象
 */
export function getParams(urlStr) {
  var url = urlStr || location.search // 获取url中"?"符后的字串
  var theRequest = {}
  var strs = ''
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      var keyvalue = strs[i].split('=')
      if (keyvalue[1] !== '') {
        theRequest[keyvalue[0]] = unescape(keyvalue[1])
      }
    }
  }
  return theRequest
}

// 获取url查询 传key时获取单个参数 不传获取所有参数
export function getParamsByKey(key, url) {
  url = url ?? location.search
  let request = {}
  if (url.indexOf('?') != -1) {
    const idx = url.indexOf('?')
    let str = url.substr(idx + 1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      let keyVals = strs[i].split('=')
      request[keyVals[0]] = unescape(keyVals[1])
    }
  }
  return key != undefined ? request[key] : request
}

// 金额保留小数点2位
export function formatMoney(value) {
  if (value === 0) {
    return 0
  } else if (!value) {
    return '--'
  } else if (!Number(value)) {
    return '--'
  }
  return (value / 100).toFixed(2)
}

// 裁剪图片
export function formatImage(url, size = 600) {
  if (url) {
    const resize = `?imageMogr2/auto-orient/thumbnail/${size}x`
    let newurl = url.split('?')[0] || ''
    return newurl.replace('i2.vzan.', 'i2cut.vzan.') + resize
  } else {
    return ''
  }
}

// 将日期字符串转换为Date对象
export function fixDate(timestr) {
  if (!timestr) return
  if (typeof timestr === 'object') {
    return timestr
  } else {
    return new Date(timestr.replace(/-/g, '/'))
  }
}

// 获取倒计时时间差
export function timeDiff(time1, time2) {
  const diff =
    new Date(fixDate(time1)).getTime() -
    new Date(fixDate(time2) || Date.now()).getTime()
  if (diff > 0) {
    return diff
  } else {
    return 0
  }
}

// 限时折扣专用 判断时间是否接近
export function isNear(time1, time2) {
  return (
    new Date(fixDate(time1)).getTime() - Date.now() < time2 * 60 * 60 * 1000
  )
}

// 限时折扣专用 取最小价格
export function miniPrice(price) {
  return ((price + '').split('~')[0] * 1).toFixed(2)
}

/**
 * @description 复制
 * @param value<string> 复制内容
 */
export const copy = (value, callback) => {
  if (!value) return
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', value)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  document.body.removeChild(input)
  if (callback && typeof callback) callback()
}
/**
 * @description 复制多行
 * @param value<string> 复制内容
 */
export const copyMultipleLines = (value, callback) => {
  if (!value) return

  // 使用 textarea 而不是 input，以支持换行
  const textarea = document.createElement('textarea')

  // 设置样式避免影响页面布局
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'

  textarea.value = value // textarea 可以保留换行符
  document.body.appendChild(textarea)
  textarea.select()

  try {
    const success = document.execCommand('copy')
    if (success && callback && typeof callback === 'function') {
      callback()
    }
  } catch (err) {
    console.error('复制失败:', err)
  } finally {
    document.body.removeChild(textarea)
  }
}

// 获取 URL 的参数
export function GetParmas() {
  var url = location.search // 获取url中"?"符后的字串
  // eslint-disable-next-line no-new-object
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    let strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      var keyvalue = strs[i].split('=')
      if (keyvalue[1] !== '') {
        theRequest[keyvalue[0]] = unescape(keyvalue[1])
      }
    }
  }
  return theRequest
}

let timerReachBottom = 0
// 计算是否触底
export function isReachBottom(dom, callback, distance = 0) {
  if (
    Math.ceil(dom.scrollTop + dom.clientHeight) + Number(distance) >=
    Math.ceil(dom.scrollHeight)
  ) {
    clearTimeout(timerReachBottom)
    timerReachBottom = null
    timerReachBottom = setTimeout(() => {
      callback && callback()
    }, 500)
  }
}

// clone 对象
export function $clone(obj) {
  try {
    return JSON.parse(JSON.stringify(obj))
  } catch (error) {
    return null
  }
}
/**
 * 判断是否在直播页
 * @return void
 */
export function inLivePage() {
  var url = window.parent.location.href
  if (url.includes('tvchat') || url.includes('live/page')) {
    return true
  } else {
    return false
  }
}

// 生成从minNum到maxNum的随机数
export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10)
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    default:
      return 0
  }
}

export function loadJS(url, callback) {
  let script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = 'async'
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null
        if (typeof callback === 'function') {
          callback()
        }
      }
    }
  } else {
    script.onload = function () {
      if (typeof callback === 'function') {
        callback()
      }
    }
  }
  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

export function getEnv() {
  return process.env.VUE_APP_BUILD_FOR
}
export function isBlue() {
  return window.location.origin == 'https://wxty.vzan.com'
}
/**
 * @description 跳转至微赞直播页
 * @param tpid {Number} 微赞话题ID
 * @param params {Object} 跳转参数
 */
export function filterWeiZanUrl(tpid, params) {
  const trainIframeStore = useIframe()
  let openUrl = tpid
    ? `/live/tvchat-${tpid}?v=${new Date().getTime()}`
    : `/live/livedetail-${getUrlParam('zbid')}`
  if (tpid && params && Object.keys(params).length > 0) {
    Object.keys(params).forEach(key => {
      openUrl += `&${key}=${params[key]}`
    })
  }
  if (trainIframeStore.isFrame) {
    trainIframeStore.notifyToUrl(openUrl)
  } else {
    window.location.href = openUrl
  }
}

/**
 * 获取url中指定的参数
 * @param {*参数名称} name
 */
export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg) // 匹配目标参数
  if (r != null) {
    return decodeURI(r[2])
  }
  return '' // 返回参数值
}

export function decodeCompletion(str) {
  if (str) {
    let reg1 = new RegExp('customWiseTagStart', 'g')
    let reg2 = new RegExp('customWiseTagEnd', 'g')
    let reg3 = new RegExp('closeWiseTag', 'g')
    return str
      .replace(reg1, '<wise')
      .replace(reg2, '</wise>')
      .replace(reg3, '>')
  }
}

// 处理作业类型为问答题的题目
export const handleEssayQuestionVal = str => {
  // .replace(/\(\S*\d\)/g,"")
  str = decodeCompletion(str)
  let newstr = str
    .replace(/ id\s*?=\s*?([‘"])[\s\S]*?\1/g, '')
    .replace(/\(\D{2}\d\)/g, 'EssayWise')
    .replace(/\n/g, '<br/>')
  let strs = newstr.split('<wise>')
  // eslint-disable-next-line no-array-constructor
  let fillblanksArr = new Array()
  let answerArr = []
  for (let i = 0; i < strs.length; i++) {
    let text_obj = null
    let line_obj = null
    if (strs[i].indexOf('</wise>') != -1) {
      let temps = strs[i].split('</wise>')
      for (let j = 0; j < temps.length; j++) {
        if (temps[j].length) {
          if (temps[j].includes('EssayWise')) {
            line_obj = {
              id: 'l' + i + j,
              index: answerArr.length,
              name: '____',
              type: 'line',
            }
            answerArr.push({
              id: 'l' + i + j,
              text: '',
            })
          } else {
            text_obj = {
              id: 't' + i + j,
              name: temps[j],
              type: 'text',
            }
          }
          if (text_obj != null && text_obj != '' && text_obj != 'undifined') {
            fillblanksArr.push(text_obj)
          }
          if (line_obj != null && line_obj != '' && line_obj != 'undifined') {
            fillblanksArr.push(line_obj)
          }
        }
        text_obj = null
        line_obj = null
      }
    } else {
      text_obj = {
        id: 't' + i,
        name: strs[i],
        type: 'text',
      }
      if (text_obj != null && text_obj != '' && text_obj != 'undifined') {
        fillblanksArr.push(text_obj)
      }
      text_obj = null
      line_obj = null
    }
  }
  return {
    fillblanksArr,
    answerArr,
  }
}

// 判断是否PC浏览器
export function isPCBrowser() {
  return !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
}

// 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 将整数转换成 时：分：秒的格式
export function realFormatSecond(second) {
  const secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    const mimute = Math.floor(second / 60)
    second = second - mimute * 60
    return (
      (mimute > 9 ? mimute : '0' + mimute) +
      ':' +
      (second > 9 ? second : '0' + second)
    )
  } else {
    return '00:00'
  }
}

export const indexToString = index => {
  var charcode
  return index
    .toString(26)
    .split('')
    .map(function (item) {
      charcode = item.charCodeAt(0)
      charcode += charcode >= 97 ? 10 : 49
      return String.fromCharCode(charcode)
    })
    .join('')
    .toUpperCase()
}

// 接入微赞返回直播间
export const goToHome = tpid => {
  filterWeiZanUrl(tpid)
}

export function formatScore(val) {
  return Number(val / 10)
}

export const filterTimeFormat = (time, cFormat = 'yyyy-mm-dd') => {
  if (!cFormat) {
    cFormat = 'YYYY-MM-DD HH:mm'
  }
  if (!time || time == 0) {
    return ''
  }
  return moment(time).format(cFormat)
}

// 浮点数计算精度丢失解决方案
export function formatFloat(f, digit) {
  var m = Math.pow(10, digit)
  return Math.round(f * m, 10) / m
}
// 处理价格精度问题
export function fixFloatMoney(value) {
  if (!value) {
    return 0
  }
  return formatFloat(value / 100, 2)
}

/**
 * @description 跳转至训练营营期详情
 * @param tpid {Number} 微赞话题ID
 */
export function goToCamp(campId) {
  window.location.href = `/live/m/camp/detail?zbid=${getUrlParam(
    'zbid'
  )}&id=${campId}`
}

/**
 * @description 文件大小显示：文件大小<1M时，单位为kb，显示整数，不足1KB显示1KB；2KB＞文件＞1kb，显示2KB 文件大小≥1M时，单位为M
 * @param size {Number} 文件大小 单位：字节
 * @return {String}
 */
export function formatFileSize(fileSize) {
  const size = Number(fileSize)
  if (size < 1024 * 1024) {
    if (size < 1024) {
      return '1KB'
    } else if (size < 2048) {
      return '2KB'
    } else {
      return (size / 1024).toFixed(2) + 'KB'
    }
  } else {
    return (size / 1024 / 1024).toFixed(2) + 'MB'
  }
}

/**
 * @description 去除标签
 * @param str 内容
 * @returns {string|*}
 */
export function matchReg(str) {
  if (str) {
    let reg = /<[^>]+>/g
    return str.replace(reg, '')
  } else {
    return ''
  }
}

export function isEmpty(a) {
  /* 检验空字符串 */
  if (a === '') return true
  /* 检验字符串类型的null */
  if (a === 'null') return true
  /* 检验字符串类型的 undefined	*/
  if (a === 'undefined') return true
  /* 检验 undefined 和 null */
  if (!a && a !== 0 && a !== '') return true
  /* 检验空数组	*/
  if (Array.prototype.isPrototypeOf.call(a) && a.length === 0) return true
  /* 检验空对象  */
  if (Object.prototype.isPrototypeOf.call(a) && Object.keys(a).length === 0) {
    return true
  }
  return false
}

export function isMiniProgram() {
  return /miniProgram/i.test(navigator.userAgent)
  // try {
  //   return new Promise(resolve => {
  //     if (!isWeChat()) resolve(false)
  //     const query = getParams()
  //     console.log('query', query)
  //     if (navigator.userAgent.includes('miniProgram')) return resolve(true)
  //     window.onload = async () => {
  //       window.wx.miniProgram &&
  //         (await window.wx.miniProgram.getEnv(res => {
  //           console.log('res', res)
  //           if (res.miniprogram) resolve(true)
  //         }))
  //     }
  //     if (query.f && query.f === 'sm') {
  //       return resolve(true)
  //     }
  //     if (query.fr && (query.fr === 'sm' || query.fr === 'small')) {
  //       return resolve(true)
  //     }
  //     if (window.location.origin.includes('wxamp.vzan')) {
  //       return resolve(true)
  //     }
  //     resolve(false)
  //   })
  // } catch (error) {
  //   console.error('isMiniProgram', error)
  //   return false
  // }
}

export const isWx = type => {
  // 是否微信端 pc => pc微信端 mobile => 手机微信端 work => 企微端 nowork => 微信非企微端
  const ua = navigator.userAgent
  const is = /MicroMessenger/i.test(ua)
  console.log('MicroMessenger', is)
  switch (type) {
    case 'pc':
      return is && /WindowsWechat/i.test(ua)
    case 'mobile':
      return is && !/WindowsWechat/i.test(ua)
    case 'work':
      console.log('wxwork', /wxwork/i.test(ua))
      return is && /wxwork/i.test(ua)
    case 'nowork':
      return is && !/wxwork/i.test(ua)
    default:
      return is
  }
}

/**
 * 是否为外部 APP 内嵌
 */
export function isExternalApp() {
  if (isWx() || isMiniApp() || isWx('work')) {
    console.log('微信：非内嵌 APP 环境')
    return false
  }
  const isInAppPay = /InAppPay/.test(navigator.userAgent)
  !isInAppPay && console.log('非内嵌 APP 环境')
  return isInAppPay
}

/*
 * @description 判断字符串是否为json字符串
 * @return {String}  参数对象
 */
export function isJSON(str) {
  if (typeof str == 'string') {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      console.log('It is not a string!')
      return false
    }
  }
}

/*
 * 设置link的参数，有就替换参数值，没有就加上
 * @param {*} url
 * @param {*} arg
 * @param {*} val
 */
export function setUrlArg(url, arg, val) {
  var pattern = arg + '=([^&]*)'
  var replaceText = arg + '=' + val
  if (url.match(pattern)) {
    return url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText)
  } else {
    const index = url.indexOf('#')
    if (index >= 0) {
      console.log(url.slice(index))
      return url.slice(index).match(/\?/g)
        ? url + '&' + replaceText
        : url + '?' + replaceText
    } else {
      return url.match(/\?/g)
        ? url + '&' + replaceText
        : url + '?' + replaceText
    }
  }
}

export function copyText(text, callback) {
  // 数字没有 .length 不能执行selectText 需要转化成字符串
  const textString = text.toString()
  let input = document.querySelector('#copy-input')
  if (!input) {
    input = document.createElement('input')
    input.id = 'copy-input'
    input.readOnly = 'readOnly' // 防止ios聚焦触发键盘事件
    input.style.position = 'fixed'
    input.style.left = '-300%'
    input.style.top = '-300%'
    input.style.zIndex = '-1000'
    document.body.appendChild(input)
  }

  input.value = textString
  // ios必须先选中文字且不支持 input.select();
  selectText(input, 0, textString.length)
  console.log(document.execCommand('copy'), 'execCommand')
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    typeof callback == 'function' && callback()
  } else {
    // 兼容ios端不支持execCommand方法
    setTimeout(() => {
      navigator.clipboard.writeText(textString)
      typeof callback == 'function' && callback()
    }, 0)
  }
  input.blur()

  // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
  // 选择文本。createTextRange(setSelectionRange)是input方法
  function selectText(textbox, startIndex, stopIndex) {
    if (textbox.createTextRange) {
      // e
      const range = textbox.createTextRange()
      range.collapse(true)
      range.moveStart('character', startIndex) // 起始光标
      range.moveEnd('character', stopIndex - startIndex) // 结束光标
      range.select() // 不兼容苹果
    } else {
      // firefox/chrome
      textbox.setSelectionRange(startIndex, stopIndex)
      textbox.focus()
    }
  }
}

/*
  个位数自动补零占位
 */
export function addZero(value) {
  return Number(value) < 10 ? '0' + value : value
}

// 下载含有url的文件
export function downloadUrlFile(url, fileName, callback, linkCallback) {
  const url2 = url.replace(/\\/g, '/')
  if (/android/i.test(navigator.userAgent)) {
    typeof linkCallback == 'function' && linkCallback()
    window.location.href = url2
    return
  }
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url2, true)
  xhr.responseType = 'blob'
  // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
  // 为了避免大文件影响用户体验，建议加loading
  xhr.onload = () => {
    if (xhr.status === 200) {
      // 获取文件blob数据并保存
      saveAs(xhr.response, fileName)
      typeof callback == 'function' && callback()
    }
  }
  xhr.send()
}

// 保存到本地并自动点击
function saveAs(data, name) {
  const urlObject = window.URL || window.webkitURL || window
  const export_blob = new Blob([data])
  const save_link = document.createElementNS(
    'http://www.w3.org/1999/xhtml',
    'a'
  )
  save_link.href = urlObject.createObjectURL(export_blob)
  save_link.download = name
  save_link.click()
}

// 获取富文本文字内容
export function getPlainText(richCont) {
  let value = richCont
  if (richCont) {
    value = value.replace(/\s*/g, '')
    value = value.replace(/<[^>]+>/g, '')
    value = value.replace(/↵/g, '')
    value = value.replace(/[\r\n]/g, '')
    value = value.replace(/&nbsp;/g, '')
    return value
  } else {
    return ''
  }
}

// 获取封面纯地址，不符合则给默认封面
export function getShareCover(picture, tpCover) {
  const DEFAULT_COVER = 'https://static2.sinsam.com/zhibo/img/default-cover.png'
  const IMG_REG = /^https?:\/\/(.+\/)+.+(\.(png|jpg|jpeg))$/i
  let picUrl = ''
  picUrl = tpCover ? tpCover.split('?')[0] : ''
  if (picture) {
    picUrl = picture ? picture.split('?')[0] : ''
  }
  return !IMG_REG.test(picUrl) ? DEFAULT_COVER : picUrl
}

// 企微分享
export function getSendWxWorkMsgParams(
  item,
  tpId,
  agt,
  generalAgStr,
  weComFriend,
  peid,
  isPeriod,
  lt,
  crId,
  shareConfig = { shareType: 0, preTopicId: undefined }
) {
  console.log('arguments', arguments)
  let desc = ''
  if (item.tpRemark) {
    desc = getPlainText(item.tpRemark).slice(0, 100)
  }
  if (item.tpShareRemark) {
    desc = getPlainText(item.tpShareRemark).slice(0, 100)
  }
  if (!desc) {
    desc = '点击查看详情'
  }
  let link = `${getHost()}/live/tvchat-${tpId}?shauid=${
    window.userInfo.encUserid
  }&vprid=0&sharetstamp=${Date.now()}&agt=${agt}${
    generalAgStr ? '&agtspt=' + generalAgStr : ''
  }${weComFriend ? '&wcf=' + weComFriend : ''}${peid ? '&peid=' + peid : ''}${
    lt ? '&lt=' + lt : ''
  }${crId ? '&crId=' + crId : ''}`
  if (isPeriod) {
    link = `${getHost()}/live/m/agent/period?shauid=${
      window.userInfo.encUserid
    }&zbid=${window.zbvd.zbid}&agt=${agt}&peid=${peid}${lt ? '&lt=' + lt : ''}${
      crId ? '&crId=' + crId : ''
    }${weComFriend ? '&wcf=' + weComFriend : ''}`
  } else if (shareConfig.shareType == 1 && shareConfig.preTopicId) {
    link = `${getHost()}/live/page/${shareConfig.preTopicId}?shauid=${
      window.userInfo.encUserid
    }&zbid=${window.zbvd.zbid}&agt=${agt}&peid=${peid}${lt ? '&lt=' + lt : ''}${
      crId ? '&crId=' + crId : ''
    }${weComFriend ? '&wcf=' + weComFriend : ''}`
  }
  const params = {
    msgtype: 'news',
    news: {
      link: `${link}${window.corpId ? '&cropid=' + window.corpId : ''}`,
      desc,
      title: item.tpShareTitle || item.tpName,
      imgUrl: getShareCover(item.picture, item.tpCover),
    },
  }
  console.log('params', params)
  return params
}

// 根据毫秒数格式化已持续的时间格式
export const getDurationTime = millisecond => {
  function fillZero(num) {
    if (num > 10) {
      return num
    }
    return `0${num}`
  }

  var theTime = parseInt(millisecond / 1000) // 秒
  var middle = 0 // 分
  var hour = 0 // 小时

  if (theTime >= 60) {
    middle = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (middle >= 60) {
      hour = parseInt(middle / 60)
      middle = parseInt(middle % 60)
    }
  }
  var result = ':' + fillZero(parseInt(theTime))
  if (middle > 0) {
    result = ':' + fillZero(parseInt(middle)) + result
  } else {
    return `00:00${result}`
  }
  if (hour > 0) {
    result = '' + fillZero(parseInt(hour)) + result
  } else {
    return `00${result}`
  }
  return result
}

/**
 * @description Blob导出
 * @param {Function} callback 请求数据，return后端返回结果
 * @param {Function} onError 失败执行的回调
 * @param {String} fileName 文件名
 */
export const BloblOutput = (() => {
  var timer
  return (fileName, callback, onError, onSuccess) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(async () => {
      try {
        const res = await callback()
        console.log(res)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${fileName || '数据导出'}.xls`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
        onSuccess && onSuccess()
      } catch (error) {
        if (onError && typeof onError === 'function') {
          onError(error)
        } else {
          console.log(error)
        }
      }
    }, 500)
  }
})()

// 二进制下载导出
// value 二进制数据
// name 导出文件名称，要加后缀 比如  example.xlsx
export function downloadBlob(value, name) {
  const url = window.URL.createObjectURL(
    new Blob([value], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
    })
  )
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

// 企微打开指定外部联系人窗口
export function handleopenEnterpriseChat(externalUserIds, callback) {
  wx.invoke(
    'openEnterpriseChat',
    { userIds: '', externalUserIds, groupName: '' },
    res => {
      console.log('openEnterpriseChat success!!!', res)
      if (res.err_msg == 'openEnterpriseChat:ok') {
        console.log('执行成功')
        typeof callback == 'function' && callback(true)
      } else {
        Dialog.confirm({
          title: '提示',
          message: '企微SDK加载失败，点击确定重新加载再重试',
          confirmButtonColor: '#FF8A00',
          confirmButtonText: '确定',
        })
          .then(() => {
            typeof callback == 'function' && callback(false)
          })
          .catch(() => {})
      }
    }
  )
}
// 获取档期页面地址
export function getPeriodPageUrl(
  shauid,
  zbid,
  agt,
  peid,
  lt,
  crId,
  preTpid,
  cropid
) {
  const path = preTpid ? `/live/page/${preTpid}` : '/live/m/agent/period'
  let url = `${getHost()}${path}?shauid=${shauid}&zbid=${zbid}&agt=${agt}&peid=${peid}${
    lt ? '&lt=' + lt : ''
  }${crId ? '&crId=' + crId : ''}${
    window.corpId || cropid ? '&cropid=' + (window.corpId || cropid) : ''
  }`
  return url
}

// 手机环境判断
export const isMobileAgent = type => {
  if (type == 'android') {
    return /android/i.test(navigator.userAgent)
  }
  if (type == 'iphone') {
    return /iphone/i.test(navigator.userAgent)
  }
  return /iphone|ipad|android/i.test(navigator.userAgent)
}

// 题目类型
export function filterQuestion(idx) {
  if (idx == 1) {
    return '单选题'
  } else if (idx == 2) {
    return '多选题'
  } else if (idx == 3) {
    return '不定项选择题'
  } else if (idx == 4) {
    return '判断题'
  } else if (idx == 5) {
    return '填空题'
  } else if (idx == 6) {
    return '问答题'
  } else if (idx == 7) {
    return '材料题'
  } else {
    return '--'
  }
}

// 删除主域名.vzan.com cookie
export function deleteCookie(key, domain = '.vzan.com') {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  document.cookie = `${key}=;Domain=${domain}; Path=/;expires=${exp.toGMTString()}`
}

export function clearMultiDomainCookie(key) {
  if (zbvd.domainUrl) {
    let subhost = ''
    let subhostArr = location.host.split('.')
    subhostArr.shift()
    subhost = '.' + subhostArr.join('.')
    deleteCookie(key, '.' + location.host)
    deleteCookie(key, location.host)
    deleteCookie(key, subhost)
  }
  deleteCookie(key)
  deleteCookie(key, 'wx.vzan.com')
  deleteCookie(key, 'h5.vzan.com')
  deleteCookie(key, '.hnaskj0yiq.cn')
  deleteCookie(key, location.host)
}

// 设置cookie
export function setCookie(key, value, domain = '.vzan.com') {
  document.cookie = `${key}=${value}; Domain=${domain}; Path=/`
}

// 延迟 N 秒后返回
export function delay(second) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, second)
  })
}
export const usePcPage = !/android|iphone|linux|micromessenger/i.test(
  navigator.userAgent
)

// 获取所有域名
export function getAllDomain(url = window.location.href) {
  try {
    const { hostname } = new URL(url)
    const parts = hostname.split('.')

    const domains = []
    for (let i = 0; i < parts.length - 1; i++) {
      const domain = parts.slice(i).join('.')
      domains.push(domain)
    }

    return domains
  } catch (e) {
    return []
  }
}

export function isMiniApp(strict) {
  // 微赞小程序
  if (strict === 'vzanlive') {
    return (
      window.__vzan_miniapp ||
      /miniProgram\/wx726b915121e07245|miniProgram\/wxbc16f54cc6946fa6|miniProgram\/wx06e1e111eb26d3cf|miniProgram\/wx7daba53322d28aae|miniProgram\/wx92d650b253f8f2e3|miniProgram\/wx291cee336ee3530b|miniProgram\/wx42efddd4847df063|miniProgram\/wx8af9b67824605e5a|miniProgram\/wx8d62711f6741ff6c|miniProgram\/wx47e4f4a167e2ff3f|miniProgram\/wx62a2649c5df06dd1|miniProgram\/wx1cbdfd80d028b07d/.test(
        window.navigator.userAgent
      )
    )
  }
  // 云选小程序
  if (strict === 'select_miniapp') {
    return /miniProgram\/wxac3abab7674468c0/.test(window.navigator.userAgent)
  }
  if (!strict) {
    return /miniProgram/i.test(navigator.userAgent)
  } else {
    const query = getParams()
    const isType1 = /miniProgram/i.test(navigator.userAgent)
    const isType2 = query.f && query.f === 'sm'
    const isType3 = query.fr && (query.fr === 'sm' || query.fr === 'small')
    const isType4 = window.location.origin.includes('wxamp.vzan')
    return isType1 || isType2 || isType3 || isType4
  }
}

/**
 * 获取小程序appid
 * @returns {string|string|string}
 */
export function getMiniAppId() {
  if (!isMiniApp()) {
    return ''
  }
  // 使用正则表达式匹配 miniProgram/ 和空格之间的字符串
  const regex = /miniProgram\/([^ ]*)/
  const match = navigator.userAgent.match(regex)
  // 如果匹配成功，则提取结果
  const extractedString = match && match[1]
  return extractedString || ''
}

// 判断两个值是否完全一致，如果是对象则判断键值对是否一致
export function isEqual(a, b) {
  if (a === b) return true
  if (
    typeof a !== 'object' ||
    typeof b !== 'object' ||
    a === null ||
    b === null
  ) {
    return false
  }

  const keysA = Object.keys(a)
  const keysB = Object.keys(b)

  if (keysA.length !== keysB.length) return false

  // eslint-disable-next-line no-unused-vars
  for (const key of keysA) {
    if (!keysB.includes(key) || !isEqual(a[key], b[key])) {
      return false
    }
  }
  return true
}

export function callPhone(phone) {
  if (/android/i.test(navigator.userAgent)) {
    window.open(`tel:${phone}`)
  } else {
    location.href = `tel:${phone}`
  }
}

export class OnceFetch {
  constructor(asyncFunc) {
    this.callback = []
    this.pending = false
    this.finished = false
    this.asyncFunc = asyncFunc
    this.result = null
  }
  getData() {
    return new Promise(resolve => {
      if (this.finished) {
        resolve(this.result)
      }
      if (this.pending) {
        this.callback.push(resolve)
      }
      if (!this.pending) {
        this.pending = true
        this.asyncFunc().then(res => {
          this.result = res
          this.finished = true
          this.callback.forEach(cb => cb(res))
          this.callback = []
          resolve(res)
        })
      }
    })
  }
}

/** 判断页面是否在iframe中 */
export function isInIframe() {
  return window.self !== window.top
}
/**
 * usage
 * setWithExpiry('myKey', 'myValue', 60000); // 设置过期时间为 60 秒
 * console.log(getWithExpiry('myKey')); // 输出 'myValue'，在 60 秒内有效
 * */
// 设置带有过期时间的数据到 localStorage
export function setWithExpiry(key, value, ttl) {
  const now = new Date()
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

// 获取带有过期时间的数据
export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

// 跳转到个人中心
export function goMine(zbid) {
  if (zbid) {
    location.href = `/live/m/mine/index?zbid=${zbid}`
  } else {
    location.href = `/live/m/mine/index`
  }
}
// 跳转携带当前链接参数
export function jumpLinkCopyCurrentQuery(
  url,
  query,
  excludeKey = ['v', 'jumpitd', 'zbid', 'tpid', 'tpfskip', 'zbId', 'tpId']
) {
  Object.keys(query).forEach(key => {
    let value = query[key]
    if (!(url.indexOf(key) > -1) && !excludeKey.includes(key)) {
      if (url.indexOf('?') === -1) {
        url += '?'
      }
      url += `&${key}=${value}`
    }
  })
  return url
}
// 解析 window.location.search 为对象
export function parseQueryString(queryString) {
  // 去掉开头的 '?'（如果有）
  if (queryString.startsWith('?')) {
    queryString = queryString.slice(1)
  }

  // 分割字符串为 key=value 对
  const keyValuePairs = queryString.split('&')

  // 初始化结果对象
  const result = {}

  // 遍历每个 key=value 对
  keyValuePairs.forEach(pair => {
    // 分割 key 和 value
    const [key, value] = pair.split('=')
    // 将 key 和 value 存入结果对象
    result[key] = value
  })

  return result
}
// 扁平化数据
export const toLineData = (data, { childrenKey = 'children' } = {}) => {
  const stack = [...data]
  const nodes = []
  while (stack.length > 0) {
    const item = stack.shift()
    const children = item[childrenKey]
    nodes.push(item)
    if (children && Array.isArray(children)) {
      for (let i = children.length - 1; i >= 0; i--) {
        stack.unshift(children[i])
      }
    }
  }
  return nodes
}
// 唯一id
export function getUid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
/** 获取当前用户会员等级id */
export function getMemberLevelId() {
  if (
    !window.userInfo ||
    !window.userInfo.member ||
    !window.userInfo.member.isMember
  ) {
    return -1
  }
  return window.userInfo.member.basicId
}

/** 获取具体的时间段 */
export function setTimeRange(value) {
  const timeRanges = {
    1: { days: 0 },
    2: { days: 1 },
    3: { days: 7 },
    4: { days: 30 },
    5: { days: 60 },
  }
  const range = timeRanges[value]
  if (!range) return []
  if (range.days == 1) {
    const yesterday = moment().subtract(1, 'days')
    return [
      yesterday.startOf('day').format('YYYY-MM-DD'),
      yesterday.endOf('day').format('YYYY-MM-DD'),
    ]
  }
  const start = moment()
    .subtract(range.days > 0 ? range.days - 1 : range.days, 'days')
    .startOf('day')
    .format('YYYY-MM-DD')
  const end = moment().endOf('day').format('YYYY-MM-DD')
  return [start, end]
}

/**
 * 获取顶级域名 (不包含端口号),
 * 例如: wx.vzan.com => vzan.com
 * 如需获取端口号, 请使用 window.location.host
 * @returns {string} 顶级域名
 */
export function getTopLevelDomain() {
  const domain = window.location.hostname
  const parts = domain.split('.')
  const secondLevelDomains = ['com.cn', 'net.cn', 'org.cn', 'gov.cn', 'edu.cn']
  const lastTwoParts = parts.slice(-2).join('.')
  if (secondLevelDomains.includes(lastTwoParts)) {
    return parts.slice(-3).join('.')
  } else if (parts.length > 2) {
    return parts.slice(-2).join('.')
  } else {
    return domain
  }
}
export function getVideoFirstFrame(url) {
  return new Promise(function (resolve) {
    let dataURL = ''
    let video = document.createElement('video')
    video.setAttribute('crossOrigin', 'Anonymous')
    video.setAttribute('src', url)
    video.setAttribute('preload', 'auto') // 不设置该项就不会开启预先加载视频，那么拿到的会是黑屏
    // 如果不设置currentTime，画出来的图片是空的 当前为截取第0.001秒
    video.currentTime = 0.001
    video.addEventListener('loadeddata', function () {
      video.setAttribute('width', video.videoWidth)
      video.setAttribute('height', video.videoHeight)
      let canvas = document.createElement('canvas')
      let width = video.width // canvas的尺寸和图片一样
      let height = video.height
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(video, 0, 0, width, height) // 绘制canvas
      dataURL = canvas.toDataURL('image/jpeg') // 转换为base64
      // 转换成file
      const arr = dataURL.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = window.atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      const FILE = new File([u8arr], 'cover' + Date.now() + '.jpeg', {
        type: mime,
      })
      resolve({
        dataURL, // 预览路径
        file: FILE, // 上传的文件
      })
    })
  })
}
// 元素全屏
export function fullScreen(dom) {
  if (dom.webkitRequestFullScreen) {
    dom.webkitRequestFullScreen()
  } else if (dom.webkitEnterFullScreen) {
    dom.webkitEnterFullScreen()
  } else if (dom.requestFullscreen) {
    dom.requestFullscreen()
  } else if (dom.mozRequestFullScreen) {
    dom.mozRequestFullScreen()
  } else if (dom.msRequestFullScreen) {
    dom.msRequestFullScreen()
  }
}

/**
 * 是否在门店报表页面
 */
export function isInStoreRecord() {
  const url = new URL(location.href)
  return url.pathname.includes('/agent/storeRecord')
}

export function useWeappEnvVersion() {
  return getEnv() === 'prod' ? 'release' : 'develop'
}
// 限制字数在length长度 超出部分显示...
export function limit(str, length = 8) {
  if (length == 0) return str
  return str.length <= length ? str : `${str.slice(0, length)}...`
}

// 获取不同环境的域名
export function getHost() {
  const isWxWork = isWx('work')
  const WxWorkHost = 'https://h5.vzan.com'
  try {
    // 配置了固定域名
    const isFixDomain = zbvd.managerDomainUrl == location.origin
    if (isWxWork || isFixDomain) {
      return window.zbvd
        ? window.zbvd.domainUrl || window.zbvd.wapDomainUrl || WxWorkHost
        : WxWorkHost
    } else {
      return location.origin
    }
  } catch (e) {
    console.log(e)
    return location.origin
  }
}
/**
 * * 批量替换全局样式变量
 */
export const updateCssVariables = variables => {
  const root = document.documentElement
  for (const [key, value] of Object.entries(variables)) {
    root.style.setProperty(key, value)
  }
}

/**
 * 打开地图导航
 * @param {Object} option - 导航参数配置对象
 * @param {String} option.address - 地址详情信息
 * @param {Number} option.latitude - 纬度坐标，浮点数
 * @param {Number} option.longitude - 经度坐标，浮点数
 * @param {String} [option.title] - 位置名称
 * @param {String} [option.name] - 位置名称，与title相同，优先使用title
 * @description
 * 函数会优先尝试使用window.parent.openWxMap方法(应用内导航)，
 * 若失败则尝试使用微信SDK的wx.openLocation接口(微信内导航)
 */
export function openNavigation(option = {}) {
  if (!option || !option.address) {
    Toast('地址信息不存在')
    return
  }

  // 确保有经纬度信息
  const latitude = option.latitude || 0
  const longitude = option.longitude || 0
  const name = option.title || ''
  const address = option.address || ''

  // 如果没有有效的经纬度，提示用户
  if (!latitude || !longitude) {
    Toast('地址坐标不存在，无法导航')
    return
  }

  if (window.parent && typeof window.parent.openWxMap === 'function') {
    try {
      window.parent.openWxMap({
        latitude,
        longitude,
        name,
        address,
      })
      return
    } catch (error) {
      console.error('应用内导航调用失败:', error)
      // 继续尝试使用微信导航
    }
  }

  // 使用微信SDK的openLocation接口
  if (window.wx && typeof window.wx.openLocation === 'function') {
    try {
      window.wx.openLocation({
        latitude: parseFloat(latitude), // 纬度，浮点数
        longitude: parseFloat(longitude), // 经度，浮点数
        name, // 位置名
        address, // 地址详情说明
        scale: 18, // 地图缩放级别,整形值,范围从1~28,默认为18
        infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
      })
      return
    } catch (error) {
      console.error('微信导航调用失败:', error)
    }
  }

  // 如果两种方式都失败，提示用户
  Toast('无法打开导航')
}

// 将整数转换成 时：分：秒的格式
export function realFormatSecond2(second = 0) {
  const secondType = typeof second
  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)
    if (second > 3600) {
      let h = Math.floor(second / 3600)
      let m = Math.floor((second / 60) % 60)
      let s = Math.floor(second % 60)
      return `${h}时${m}分${s}秒`
    } else if (second > 60) {
      const minute = Math.floor(second / 60)
      second = second - minute * 60
      if (second > 0) {
        return minute + '分' + second + '秒'
      } else {
        return minute + '分'
      }
    } else {
      return second + '秒'
    }
  } else {
    return '0秒'
  }
}
// 过滤手机号中间4位数
export function filterPhone(phone) {
  try {
    var phoneres = phone.match(/0?(13|14|15|16|17|18|19)[0-9]{9}/g)
    phoneres &&
      phoneres.length &&
      phoneres.forEach(item => {
        if (item.length >= 11) {
          phone = phone.replace(
            item,
            item.replace(/(.{3}).*(.{4})/, '$1****$2')
          )
        }
      })
    return phone
  } catch (err) {
    return ''
  }
}

/**
 * 将Promise转换为统一格式的返回结果
 * @param {Promise} promise - 需要处理的Promise对象
 * @returns {Array} 返回一个数组，第一个元素是错误对象(成功时为null)，第二个元素是Promise的结果(失败时为undefined)
 */
export function to(promise) {
  return promise
    .then(data => {
      return [null, data]
    })
    .catch(err => [err, undefined])
}

// 将对象所有 key 的首字母转为小写
export function keysToLowerCase(obj) {
  if (typeof obj !== 'object' || obj === null) return obj
  if (Array.isArray(obj)) return obj.map(keysToLowerCase)
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1)
    acc[newKey] = keysToLowerCase(obj[key])
    return acc
  }, {})
}

/**
 * 是否为外部 APP 内嵌
 */
export function isVzanMiniAppPayment() {
  if (isWx() || isMiniApp() || isWx('work')) {
    return false
  }
  const isInAppPay = /(Vzan|Third)\/miniAppPayment/.test(navigator.userAgent)
  return isInAppPay
}

// 生成域名规则如下
export function generateDomain(domain, agentId) {
  if (!domain || !agentId) {
    return getHost()
  }
  // 如果域名有协议https:// 或者 http:// 则提取出来
  const protocol = domain.match(/^https?:\/\//)?.[0] || ''
  // 移除协议部分，只处理域名
  const cleanDomain = domain.replace(/^https?:\/\//, '')
  const domainArr = cleanDomain.split('.')
  const firstOne = domainArr[0] || ''
  // 获取当前的月日
  const dateStr = window.getDateValue()
  // 如果第一个是vzb结尾, 则在第一个的vzb前面插入代理ID
  if (firstOne.endsWith('vzb')) {
    const newOne = `${firstOne.slice(
      0,
      -3
    )}${agentId}${dateStr}${firstOne.slice(-3)}`
    domainArr[0] = newOne
  }
  // 如果第一个不是vzb结尾, 则在第一个的后面插入代理ID
  if (!firstOne.endsWith('vzb')) {
    const newOne = `${firstOne}${agentId}${dateStr}`
    domainArr[0] = newOne
  }
  return `${protocol}${domainArr.join('.')}`
}
/** 独立小程序内嵌直播页 */
export function isStoreMiniApp() {
  return isMiniApp() && window.getIsIndependentMiniAppDomain()
}

export function getWxWorkDomain() {
  return 'https://h5.snet.weizan.cn'
}

export const useBanPlayer = openConfig => {
  // 第三方小程序 开启白名单的放开
  if (openConfig && openConfig.includes('livepage_no_auth')) {
    return false
  }
  // 不是微信环境 统一放开
  if (!isWx()) return false
  // pc微信 包括小程序pc 统一true
  if (isWx('pc')) return true
  // 微信环境下 不是小程序内嵌 统一true
  if (!isMiniApp()) return true
  // 小程序内嵌下 商家小程序和微赞小程序 统一true
  if (isStoreMiniApp() || isMiniApp('vzanlive')) return true
  return true
}
